export default "__VITE_ASSET__CAop6hG9__"